import { type ButtonHTMLAttributes } from 'react';
import { cn } from '@/core/lib/cn';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-fv-primary text-white hover:bg-fv-primaryDark',
  secondary: 'border border-fv-border bg-white text-fv-text hover:bg-fv-surfaceLow',
  danger: 'bg-fv-error text-white hover:opacity-90',
  ghost: 'text-fv-muted hover:text-fv-text',
};

export function Button({
  variant = 'primary',
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-4 py-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-fv-primary/40 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-60',
        VARIANTS[variant],
        className,
      )}
      {...props}
    />
  );
}
